<div class="image-container">
  <div
    *ngFor="let url of URLS; let last = last"
    style="background-size: cover; background-position: center"
    [style.background-image]="'url(' + url + ')' | safe : 'style'"
    [style.grid-row]="(URLS.length === 3 && last ? '1 / span 2' : 'auto') | safe : 'style'"
  ></div>
</div>
